import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationOwner } from 'app/model/RegistrationRequest';
import { Suburb } from 'app/model/suburbs';
import { OperatorFunction, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'pharmacy-owner-ngbd-modal-content',
  templateUrl: './pharmacy-registration-owner.component.html',
  styleUrls: ['./pharmacy-registration-owner.component.scss']
})

export class PharmacyOwnerNgbdModalContent implements OnInit {
  @Input() ro: RegistrationOwner;
  @Output() passEntry: EventEmitter<RegistrationOwner> = new EventEmitter<RegistrationOwner>();
  @Input() suburbs: Suburb[];

  constructor(public activeModal: NgbActiveModal) {
    
      this.ro = new RegistrationOwner();
  }
  ngOnInit(): void {
  }

  search: OperatorFunction<string, readonly Suburb[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 2 ? []
        : this.suburbs.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    )

  formatter = (x: any) => x.name + ' - ' + x.state.name + ' - ' + x.postCode.name;


  save() {
    this.passEntry.emit(this.ro)
    this.activeModal.close();
  }

  copyAddressChange(): void {
    if (this.ro.pharmacyAddressCopy) {
      this.ro.postalAddressStreet1 = this.ro.pharmacyAddressStreet1;
      this.ro.postalAddressStreet2 = this.ro.pharmacyAddressStreet2;
      this.ro.postalSuburb = this.ro.pharmacySuburb;
      this.ro.postalState = this.ro.pharmacyState;
      this.ro.postalSuburbId = this.ro.pharmacySuburbId;
      this.ro.postalStateId = this.ro.pharmacyStateId;
      this.ro.postalPostCodeId = this.ro.pharmacyPostCodeId;
      this.ro.postalPostCode = this.ro.pharmacyPostCode;
    }
  };

  suburbChange = (suburb: Suburb) => {
    this.ro.pharmacyState = suburb.state.name;
    this.ro.pharmacyStateId = suburb.state.id;
    this.ro.pharmacyPostCode = suburb.postCode.name;
    this.ro.pharmacyPostCodeId = suburb.postCode.id;
    this.ro.pharmacySuburbId = suburb.id;
  }


  postalSuburbChange = (suburb: Suburb) => {
    this.ro.postalState = suburb.state.name;
    this.ro.postalStateId = suburb.state.id;
    this.ro.postalPostCode = suburb.postCode.name;
    this.ro.postalPostCodeId = suburb.postCode.id;
    this.ro.postalSuburbId = suburb.postCode.id;
  }

}
